<template>
  <section class="hero">
    <div class="hero__container">
      <div class="hero__content d-flex __column gap-6">
        <h1 class="hero__title fw-700">
          {{ $t("Become a Featured Creator") }}
        </h1>

        <p class="hero__text">
          {{
            $t(
              "Are you ready to share original content and grow your audience with a world-renowned lifestyle brand? Join our exclusive creator platform and showcase your work to an engaged community."
            )
          }}
        </p>

        <landing-creators-button class="hero__button" :to="{ name: 'becomeCreatorJoin' }">
          {{ $t("Become a Creator Now") }}
        </landing-creators-button>
      </div>

      <div class="hero__gallery">
        <base-picture
          v-for="(image, index) in images"
          :key="index"
          class="hero__image"
          :src="image + '.png'"
          :srcset="image + '.png 1x,' + image + '_2x.png 2x'"
          :webp-srcset="image + '.webp 1x,' + image + '_2x.webp 2x'"
          :alt="$t('Creator preview')"
        >
        </base-picture>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import BasePicture from "@/components/Base/BasePicture";
import LandingCreatorsButton from "./LandingCreatorsButton.vue";

export default defineComponent({
  name: "LandingCreatorsHero",
  components: { BasePicture, LandingCreatorsButton },
  setup() {
    const images = [
      "img/landingCreators/hero/landing-creators_hero_1",
      "img/landingCreators/hero/landing-creators_hero_2",
      "img/landingCreators/hero/landing-creators_hero_3",
      "img/landingCreators/hero/landing-creators_hero_4",
      "img/landingCreators/hero/landing-creators_hero_5",
      "img/landingCreators/hero/landing-creators_hero_6",
      "img/landingCreators/hero/landing-creators_hero_7",
      "img/landingCreators/hero/landing-creators_hero_8",
      "img/landingCreators/hero/landing-creators_hero_9",
    ];

    return {
      images,
    };
  },
});
</script>

<style lang="scss" scoped>
.hero {
  padding: 32px 0 80px 0;

  @include tablet-up {
    padding: 82px 0 120px 0;
  }

  &__container {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    gap: 64px;

    flex-direction: column;
    align-items: stretch;

    @include tablet-up {
      flex-direction: row;
      align-items: flex-start;
    }
  }

  &__content {
    max-width: 448px;
    flex: 1;
  }

  &__title {
    font-size: 40px;
    line-height: 46px;
    color: var(--landing-creator-primary-color);

    @include tablet-up {
      font-size: 52px;
      line-height: 58px;
    }
  }

  &__text {
    font-size: 18px;
    line-height: 28px;
    opacity: 0.8;
  }

  &__button {
    align-self: flex-start;
  }
  &__gallery {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
  }

  &__image {
    position: relative;
    overflow: hidden;
    aspect-ratio: 1 / 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
}
</style>
